import { defineStore } from 'pinia'
import { ref } from 'vue'

export const useLookupStore = defineStore('lookupstore', () => {
  // Store Models
  const email = ref("")
  const confirmationemail = ref("")
  const number = ref("")

  const resetData = () => {
    email.value = ''
    confirmationemail.value = ''
    number.value = ''
  }

  const update = (data) => {
    email.value             = data.email ?? ''
    confirmationemail.value = data.confirmationemail ?? data.email ?? ''
    number.value            = data.number ?? ''
  }

  return {
    email,
    confirmationemail,
    number,
    resetData,
    update,
  }
}, { persist:true })
